import consumer from "./consumer";

consumer.subscriptions.create("NotificationChannel", {
  async received(data) {
    if (Notification.permission === "granted") {
      new Notification(data.title, data.options);
    }
  },
});
